import { UppyFile } from '@uppy/core';
import { ClaimFileType } from '../../parcel-finder/claims/types';
import type { NestedArrayError } from '../../../hooks/useNestedArrayError';

export type UploaderRequestMeta = {};

export type UploaderResponseBody = {
  id: number;
  publicUrl: string;
  mimeType: string;
};

export type UploaderUppyFile = UppyFile<UploaderRequestMeta, UploaderResponseBody>;
export type UploaderFile = Omit<UploaderUppyFile, 'data'> & {
  id: string; // due to some weird compilation issue we need to re-define this property
  fileType?: ClaimFileType;
};

export type UploaderFilesListProps = {
  files?: Array<UploaderFile>;
  onFilesChange: (files: Array<UploaderFile>) => void;
  errors?: NestedArrayError;
};

export function isUploaderFile(file: UploaderFile | UploaderUppyFile): file is UploaderFile {
  return !(file as UploaderUppyFile).data;
}
